

import { useTranslation } from "react-i18next";
import ReactDOM from 'react-dom/client';

import { Link as LinkScroll, animateScroll as scroll, scroller } from "react-scroll";

import React, { useState, useEffect, useRef } from 'react';
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link,
    useLocation
} from "react-router-dom";



const Title = ({ title, subTitle, type }) => {
    const { t, i18n } = useTranslation();
    const location = useLocation();
    const query = new URLSearchParams(location.search);

    useEffect(() => {
    }, []);

    return <div className="">
        {type != 2 && <p className=" truncate text-xs md:text-base mb-0.5 md:mb-2 ">{title}</p>}

        <p className={`text-2xl ${type == 1 ? "" : "md:italic"}`}>{subTitle}</p>
    </div >

}


export default Title

